<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties with Writable Getter/Setter
const pageSize = computed({
    get() {
        return viewStore.pageSize
    },
    set(value) {
        if (value <= 0 || value > 50) {
            return
        }

        viewStore.setPageSize(value)

        // Reset pagination when changing the page size
        viewStore.setPage(1)
    }
})

const listingName = computed(() => viewStore.listingName)
</script>

<template>
    <label class="d-flex align-items-center">
        <input v-model.number="pageSize" class="me-2 form-control input-sm listing-options-page-size" max="50" min="1"
               size="3" type="number">
        Page size
    </label>
</template>

<style scoped>
label {
    margin-bottom: 0;
    font-size: inherit;
}

input {
    margin-left: -5px;
    margin-right: 5px;
    padding: 2px;
    width: auto !important;
    text-align: center;
}
</style>